import { makeStyles } from '@material-ui/core';

const borderColor = '#d9e2ef';
const primaryColor = '#0b63ce';
const textColor = '#172033';

export const useFuelProvisionalConfirmStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    backgroundColor: '#f7f9fc',
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    padding: theme.spacing(2),
    boxSizing: 'border-box',
    overflow: 'visible',
    borderRadius: 12,
    backgroundColor: '#f7f9fc',
    boxShadow: 'none',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3),
    },
  },
  missionHeader: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(2.5),
    border: `1px solid ${borderColor}`,
    borderRadius: 12,
    backgroundColor: '#fff',
    boxShadow: '0 4px 16px rgba(15, 23, 42, 0.08)',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: theme.spacing(2),
    },
  },
  missionTitle: {
    margin: 0,
    color: textColor,
    fontSize: '1.35rem',
    fontWeight: 700,
    lineHeight: 1.25,
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.15rem',
    },
  },
  missionReference: {
    marginTop: theme.spacing(1.25),
    color: '#334155',
    fontSize: '0.95rem',
    fontWeight: 700,
  },
  missionObject: {
    marginTop: theme.spacing(0.75),
    color: '#475569',
    fontSize: '0.82rem',
  },
  pendingChip: {
    flexShrink: 0,
    border: '1px solid #f2b84b',
    backgroundColor: '#fff9ed',
    color: '#b45309',
    fontSize: '0.75rem',
    fontWeight: 600,
    '& .MuiChip-icon': {
      color: '#d97706',
    },
  },
  scrollAlert: {
    marginTop: theme.spacing(2),
    border: '1px solid #b9d6ff',
    borderRadius: 8,
    backgroundColor: '#eff6ff',
    color: '#0757b5',
    fontSize: '0.75rem',
    '& .MuiAlert-icon': {
      color: primaryColor,
    },
  },
  contentSection: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    overflow: 'hidden',
  },
  tabsContainer: {
    width: '100%',
    marginTop: theme.spacing(2),
    border: `1px solid ${borderColor}`,
    borderRadius: 10,
    backgroundColor: '#fff',
    overflow: 'hidden',
  },
  tabs: {
    minHeight: 56,
    '& .MuiTabs-indicator': {
      height: 3,
      backgroundColor: primaryColor,
    },
    '& .MuiTab-root': {
      minHeight: 56,
      minWidth: 180,
      flex: 1,
      color: '#475569',
      fontSize: '0.82rem',
      fontWeight: 600,
      textTransform: 'none',
      borderRight: `1px solid ${borderColor}`,
    },
    '& .MuiTab-root:last-child': {
      borderRight: 0,
    },
    '& .Mui-selected': {
      color: `${primaryColor} !important`,
      backgroundColor: '#f8fbff',
    },
  },
  fieldset: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    margin: `${theme.spacing(2)}px 0`,
    padding: theme.spacing(2),
    boxSizing: 'border-box',
    overflow: 'hidden',
    border: `1px solid ${borderColor}`,
    borderRadius: 12,
    backgroundColor: '#fff',
    boxShadow: '0 4px 16px rgba(15, 23, 42, 0.06)',
  },
  fieldsetLegend: {
    padding: theme.spacing(0, 1),
    color: primaryColor,
    fontSize: '0.82rem',
    fontWeight: 700,
    letterSpacing: '0.15px',
  },
  distributionHeader: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${borderColor}`,
  },
  distributionTitle: {
    margin: 0,
    color: textColor,
    fontSize: '1rem',
    fontWeight: 700,
  },
  roundingInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.75),
    marginTop: theme.spacing(0.75),
    color: '#52657d',
    fontSize: '0.75rem',
  },
  roundingIcon: {
    color: primaryColor,
    fontSize: '1.05rem',
  },
  tableWrapper: {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    overflowX: 'auto',
    overflowY: 'hidden',
    border: `1px solid ${borderColor}`,
    borderRadius: 9,
  },
  table: {
    minWidth: 1400,
    '& .MuiTableCell-root': {
      borderBottom: `1px solid ${borderColor}`,
    },
    '& .MuiTableCell-body': {
      color: '#26354a',
      fontSize: '0.72rem',
    },
    '& .MuiTableRow-root:nth-of-type(odd) .MuiTableCell-body': {
      backgroundColor: '#fcfdff',
    },
    '& .MuiTableRow-root:hover .MuiTableCell-body': {
      backgroundColor: '#f4f8fe',
    },
  },
  tableHeaderCell: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    backgroundColor: '#f4f7fb',
    color: '#172033',
    fontSize: '0.72rem',
    fontWeight: 700,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  dateCell: {
    maxWidth: 110,
    minWidth: 110,
  },
  timeText: {
    color: '#64748b',
    fontSize: '0.68rem',
    fontStyle: 'italic',
  },
  locationCell: {
    minWidth: 260,
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
  },
  typeCell: {
    minWidth: 115,
    textAlign: 'center',
  },
  typeChip: {
    fontSize: '0.7rem',
    backgroundColor: '#f8fbff',
  },
  missionaryCell: {
    minWidth: 200,
  },
  numberCell: {
    minWidth: 130,
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
  tdBorderedLeft: {
    borderLeft: '1px solid #d4dce8',
    textAlign: 'center',
  },
  percentageContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  percentageInput: {
    width: 96,
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fff',
    },
  },
  percentageAmount: {
    color: '#64748b',
    fontSize: '0.7rem',
    whiteSpace: 'nowrap',
  },
  totalRow: {
    '& .MuiTableCell-root': {
      backgroundColor: '#f7f9fc',
      color: textColor,
      fontWeight: 700,
      whiteSpace: 'nowrap',
    },
  },
  emptyAlert: {
    marginTop: theme.spacing(2),
    fontSize: '0.75rem',
  },
  actionBar: {
    position: 'sticky',
    bottom: 0,
    zIndex: 2,
    display: 'flex',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
    padding: theme.spacing(2, 0, 0.5),
    borderTop: `1px solid ${borderColor}`,
    backgroundColor: '#f7f9fc',
    flexWrap: 'wrap',
    '& .MuiButton-root': {
      minWidth: 150,
      minHeight: 42,
      borderRadius: 7,
      fontSize: '0.8rem',
      fontWeight: 600,
      textTransform: 'none',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      '& .MuiButton-root': {
        width: '100%',
      },
    },
  },
}));

export const useTransportDataStyles = makeStyles((theme) => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(5, minmax(170px, 1fr))',
    gap: theme.spacing(1.5),
    width: '100%',
    overflowX: 'auto',
    paddingBottom: theme.spacing(0.5),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(3, minmax(190px, 1fr))',
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'repeat(2, minmax(180px, 1fr))',
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
    },
  },
  card: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    minHeight: 82,
    padding: theme.spacing(1.5),
    boxSizing: 'border-box',
    border: `1px solid ${borderColor}`,
    borderRadius: 9,
    backgroundColor: '#fff',
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: 44,
    height: 44,
    borderRadius: '50%',
    backgroundColor: '#edf5ff',
    color: primaryColor,
  },
  label: {
    color: '#52657d',
    fontSize: '0.7rem',
    lineHeight: 1.3,
  },
  value: {
    marginTop: theme.spacing(0.35),
    color: textColor,
    fontSize: '0.8rem',
    fontWeight: 700,
    lineHeight: 1.35,
    overflowWrap: 'anywhere',
  },
}));
